export default __webpack_public_path__ + "static/media/lane-1.655bc74a.svg";